export default __webpack_public_path__ + "static/new_Construction_GIF-e9887be07dce8f96d77f86a526f28c1c.gif";